"use client"

import { PhoneForwarded } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PhoneForwardedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PhoneForwardedIcon = component(Icon)({ as: PhoneForwarded })
